export default function getProvidersFromEditorProps(_ref) {
  var _linking$smartLinks;
  var linking = _ref.linking,
    smartLinks = _ref.smartLinks,
    UNSAFE_cards = _ref.UNSAFE_cards,
    autoformattingProvider = _ref.autoformattingProvider,
    media = _ref.media,
    emojiProvider = _ref.emojiProvider,
    mentionProvider = _ref.mentionProvider,
    legacyImageUploadProvider = _ref.legacyImageUploadProvider,
    taskDecisionProvider = _ref.taskDecisionProvider,
    contextIdentifierProvider = _ref.contextIdentifierProvider,
    searchProvider = _ref.searchProvider,
    macroProvider = _ref.macroProvider,
    activityProvider = _ref.activityProvider,
    collabEdit = _ref.collabEdit,
    collabEditProvider = _ref.collabEditProvider,
    presenceProvider = _ref.presenceProvider;
  var cardProvider = (linking === null || linking === void 0 || (_linking$smartLinks = linking.smartLinks) === null || _linking$smartLinks === void 0 ? void 0 : _linking$smartLinks.provider) || smartLinks && smartLinks.provider || UNSAFE_cards && UNSAFE_cards.provider;
  return {
    mediaProvider: media === null || media === void 0 ? void 0 : media.provider,
    emojiProvider: emojiProvider,
    mentionProvider: mentionProvider,
    autoformattingProvider: autoformattingProvider,
    cardProvider: cardProvider,
    activityProvider: activityProvider,
    imageUploadProvider: legacyImageUploadProvider,
    taskDecisionProvider: taskDecisionProvider,
    contextIdentifierProvider: contextIdentifierProvider,
    searchProvider: searchProvider,
    presenceProvider: presenceProvider,
    macroProvider: macroProvider,
    collabEditProvider: collabEdit !== null && collabEdit !== void 0 && collabEdit.provider ? collabEdit.provider : collabEditProvider
  };
}